import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { questionsAPI } from "../services/api";

export default function ProductQuestions({ productId, sellerId }) {
  const { currentUser } = useApp();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newQuestion, setNewQuestion] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [answerDrafts, setAnswerDrafts] = useState({});
  const [answeringId, setAnsweringId] = useState(null);

  const isOwner = currentUser?.id === sellerId;

  useEffect(() => {
    questionsAPI.getForProduct(productId)
      .then(({ questions }) => setQuestions(questions))
      .finally(() => setLoading(false));
  }, [productId]);

  const handleAsk = async () => {
    if (!currentUser) { navigate("/login"); return; }
    if (!newQuestion.trim()) return;
    setError("");
    setSending(true);
    try {
      const { question } = await questionsAPI.create({
        productId, buyerId: currentUser.id, buyerName: currentUser.name, question: newQuestion.trim(),
      });
      setQuestions(prev => [question, ...prev]);
      setNewQuestion("");
    } catch(e) {
      setError(e.message);
    } finally {
      setSending(false);
    }
  };

  const handleAnswer = async (questionId) => {
    const answer = (answerDrafts[questionId] || "").trim();
    if (!answer) return;
    setAnsweringId(questionId);
    try {
      await questionsAPI.answer({ questionId, answer });
      setQuestions(prev => prev.map(q => q.id === questionId ? { ...q, answer, answered_at: new Date().toISOString() } : q));
      setAnswerDrafts(prev => ({ ...prev, [questionId]: "" }));
    } catch(e) {
      alert(e.message);
    } finally {
      setAnsweringId(null);
    }
  };

  if (loading) return null;

  return (
    <div style={s.wrap}>
      <p style={s.title}>❓ Preguntas y respuestas</p>

      {!isOwner && (
        <div style={s.askBox}>
          <input
            style={s.askInput}
            placeholder="Hace una pregunta sobre este producto..."
            value={newQuestion}
            onChange={e => setNewQuestion(e.target.value)}
          />
          <button style={s.askBtn} onClick={handleAsk} disabled={sending}>
            {sending ? "..." : "Preguntar"}
          </button>
        </div>
      )}
      {error && <p style={s.error}>{error}</p>}

      {questions.length === 0 ? (
        <p style={s.empty}>Todavia no hay preguntas. {!isOwner && "Se la primera en preguntar!"}</p>
      ) : (
        <div style={s.list}>
          {questions.map(q => (
            <div key={q.id} style={s.item}>
              <p style={s.question}>❓ {q.question}</p>
              {q.answer ? (
                <p style={s.answer}>💬 {q.answer}</p>
              ) : isOwner ? (
                <div style={s.answerBox}>
                  <input
                    style={s.answerInput}
                    placeholder="Responder..."
                    value={answerDrafts[q.id] || ""}
                    onChange={e => setAnswerDrafts(prev => ({ ...prev, [q.id]: e.target.value }))}
                  />
                  <button style={s.answerBtn} onClick={() => handleAnswer(q.id)} disabled={answeringId === q.id}>
                    {answeringId === q.id ? "..." : "Responder"}
                  </button>
                </div>
              ) : (
                <p style={s.pending}>Sin responder todavia</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  wrap:{marginTop:20,paddingTop:16,borderTop:"0.5px solid #f0f0f0"},
  title:{fontSize:15,fontWeight:600,color:"#111",marginBottom:12},
  askBox:{display:"flex",gap:8,marginBottom:12},
  askInput:{flex:1,border:"0.5px solid #ddd",borderRadius:8,padding:"10px 12px",fontSize:14},
  askBtn:{background:"#1D9E75",color:"#fff",border:"none",borderRadius:8,padding:"10px 16px",fontSize:13,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"},
  error:{color:"#E24B4A",fontSize:13,marginBottom:8},
  empty:{color:"#888",fontSize:13},
  list:{display:"flex",flexDirection:"column",gap:12},
  item:{background:"#f9f9f9",borderRadius:10,padding:12},
  question:{fontSize:14,color:"#111",margin:0,marginBottom:6},
  answer:{fontSize:14,color:"#1D9E75",margin:0},
  pending:{fontSize:12,color:"#aaa",fontStyle:"italic",margin:0},
  answerBox:{display:"flex",gap:8,marginTop:6},
  answerInput:{flex:1,border:"0.5px solid #ddd",borderRadius:8,padding:"8px 10px",fontSize:13},
  answerBtn:{background:"#1D9E75",color:"#fff",border:"none",borderRadius:8,padding:"8px 14px",fontSize:12,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"},
};
